<template>
  <div>
    <div>
      Your email is not verified !
      <span
        class="click-here"
        @click="resendEmailVerficationLink"
      >
        Click here
      </span>
      to resend verification link to your registered email address ! <!-- Or
      <span
        @click=""
        class="click-here"
      >
        click here
      </span>
      to change your registered email address ! -->
    </div>
  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  //
  export default{
    methods:{
      ...mapMutations([
        'resendEmailVerficationLink'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// verifyEmail.vue?1c876edc